<template>
  <VcLayout column class="additionalStaff">
    <VcListbox :add-another="isAbleToCreateNewStaff"
               :add-another-label="$t('staff.staff_selection.new_staff')"
               :items="dupStaffs"
               :title="$t('staff.staff_selection.additional_staff_title')"
               add-search
               data-qa="additional-staff-listbox"
               @addNew="addNewStaff"
               @change="(selections) => $emit('change', selections)">
    </VcListbox>
    <div :class="{ 'mobile': isMobile}"
         class="additionalStaff__description">{{ $t('staff.staff_selection.description') }}
    </div>
  </VcLayout>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: 'additionalStaff',
  props: {
    currentStaffUid: {
      type: String,
      required: true
    },
    staffs: {
      type: Array,
      required: true
    },
    additionalStaffs: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    addNewStaff() {
      this.$track('New appointment - Create new staff click', {'Origin': 'additional staff dialog'})
      if (this.staff.has_new_calendar) {
        this.$frontageApi.send('calendar-action', {action: 'add-new-staff'})
        return
      }
      this.$frontageApi.send('add-new-staff')
    },
    setDisableAdditionalStaff(staff) {
      return {
        ...this.getStaffInfo(staff),
        disabled: true, tooltipContent: this.$t('staff.staff_selection.additional_staff_disabled')
      }
    },
    getStaffInfo(staff) {
      return {
        color_id: staff.color_id,
        display_name: staff.display_name,
        email: staff.email,
        full_name: staff.full_name,
        photo_path: staff.photo_path,
        role: staff.role,
        avatar: staff.avatar,
        label: staff.label,
        uid: staff.uid,
      }
    }
  },
  computed: {
    ...mapGetters('accountModule', ['account', 'staff']),
    isMobile() {
      return this.$store.getters.isMobile
    },
    dupStaffs() {
      if (!this.currentStaffUid)
        return
      return this.staffs.map((staff, index) => staff.uid === this.currentStaffUid
        ? {
          ...this.setDisableAdditionalStaff(staff),
          identifier: index
        }
        : {
          ...this.getStaffInfo(staff),
          checked: this.additionalStaffs.some(staffUid => staffUid === staff.uid),
          identifier: index
        }
      )
    },
    isAbleToCreateNewStaff() {
      return this.account.staff.role === 'admin' && this.staff.role === 'admin'
    }
  }
}

</script>

<style lang="scss" scoped>
.additionalStaff {
  &__description {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    margin-block-start: 8px;
    color: #616161;
    &.mobile {
      line-height: 20px;
      letter-spacing: 0.02em;
      margin-block-start: 12px;
    }
  }
  ::v-deep {
    .v-list-item.v-list-item--disabled {
      display: none;
    }
  }
}

</style>
